import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const LANDING_URL = process.env.REACT_APP_LANDING_URL || 'https://referomed.ru';

export default function Register() {
  const [form, setForm] = useState({ email: '', password: '', password2: '', first_name: '', last_name: '', middle_name: '', birth_date: '', phone: '', specialty: '' });
  const [acceptedOffer, setAcceptedOffer] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('token')) navigate('/dashboard');
  }, []);

  const handle = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleRegister = async () => {
    if (!form.first_name || !form.last_name || !form.birth_date || !form.email || !form.password || !form.specialty) {
      setError('Заполните все обязательные поля');
      return;
    }
    if (form.password !== form.password2) {
      setError('Пароли не совпадают');
      return;
    }
    if (form.password.length < 6) {
      setError('Пароль должен быть не менее 6 символов');
      return;
    }
    try {
      await axios.post(`${API}/auth/register`, {
        email: form.email,
        password: form.password,
        first_name: form.first_name,
        last_name: form.last_name,
        middle_name: form.middle_name,
        birth_date: form.birth_date,
        phone: form.phone,
        specialty: form.specialty,
        accepted_offer: acceptedOffer,
      });
      setSuccess('Регистрация успешна! Войдите в аккаунт.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (e) {
      setError(e.response?.data?.detail || 'Ошибка регистрации');
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <img src="/refero-logo-vert.svg" alt="Refero" style={{ height: 56 }} />
          <span style={styles.logoSub}>Регистрация врача</span>
        </div>
        <div style={styles.row}>
          <input style={styles.input} placeholder="Фамилия *" value={form.last_name} onChange={handle('last_name')} />
          <input style={styles.input} placeholder="Имя *" value={form.first_name} onChange={handle('first_name')} />
        </div>
        <input style={styles.inputFull} placeholder="Отчество" value={form.middle_name} onChange={handle('middle_name')} />
        <label style={styles.label}>Дата рождения *</label>
        <input style={styles.inputFull} type="date" value={form.birth_date} onChange={handle('birth_date')} />
        <input style={styles.inputFull} type="email" placeholder="Email *" value={form.email} onChange={handle('email')} />
        <input style={styles.inputFull} placeholder="Специальность *" value={form.specialty} onChange={handle('specialty')} />
        <input style={styles.inputFull} type="password" placeholder="Пароль *" value={form.password} onChange={handle('password')} />
        <input style={styles.inputFull} type="password" placeholder="Подтвердите пароль *" value={form.password2} onChange={handle('password2')} />
        <input style={styles.inputFull} placeholder="Телефон" value={form.phone} onChange={handle('phone')} />
        <div style={styles.notice}>
          💡 Выплаты доступны только для самозанятых и ИП. Реквизиты можно добавить позже.
        </div>
        <label style={styles.checkboxRow}>
          <input type="checkbox" checked={acceptedOffer} onChange={e => setAcceptedOffer(e.target.checked)} />
          <span>
            Принимаю условия{' '}
            <a href={`${LANDING_URL}/oferta.html`} target="_blank" rel="noopener noreferrer" style={styles.offerLink}>оферты</a>
          </span>
        </label>
        {error && <div style={styles.error}>{error}</div>}
        {success && <div style={styles.successMsg}>{success}</div>}
        <button style={{ ...styles.btn, ...(acceptedOffer ? {} : styles.btnDisabled) }} onClick={handleRegister} disabled={!acceptedOffer}>
          Зарегистрироваться
        </button>
        <Link to="/login" style={styles.link}>Уже есть аккаунт? Войти</Link>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f5f7fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, boxSizing: 'border-box' },
  card: { background: 'white', borderRadius: 16, padding: 40, width: '100%', maxWidth: 440, boxSizing: 'border-box', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', gap: 12 },
  logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 8 },
  logoText: { fontSize: 28, fontWeight: 700, color: '#1B2B4B', letterSpacing: -1 },
  logoSub: { fontSize: 13, color: '#999', marginTop: 2 },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  input: { padding: '12px 16px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14, outline: 'none', width: '100%' },
  inputFull: { padding: '12px 16px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14, outline: 'none' },
  label: { fontSize: 12, color: '#888', marginBottom: -6 },
  btn: { background: '#2EC4B6', color: 'white', border: 'none', padding: '13px', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 4 },
  btnDisabled: { background: '#cbd5e1', cursor: 'not-allowed' },
  checkboxRow: { display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#475569', cursor: 'pointer' },
  offerLink: { color: '#2EC4B6', fontWeight: 600 },
  error: { background: '#fef2f2', border: '1px solid #fca5a5', color: '#dc2626', padding: '10px 14px', borderRadius: 8, fontSize: 13 },
  successMsg: { background: '#e8f8f7', border: '1px solid #2EC4B6', color: '#1a7a74', padding: '10px 14px', borderRadius: 8, fontSize: 13 },
  link: { color: '#2EC4B6', textAlign: 'center', fontSize: 13, textDecoration: 'none' },
  notice: { background: '#fffbeb', border: '1px solid #fcd34d', color: '#92400e', padding: '10px 14px', borderRadius: 8, fontSize: 12 }
};